var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M7.5 14.5C3.63401 14.5 0.5 11.366 0.5 7.5C0.5 5.26904 1.54367 3.28183 3.1694 2M7.5 0.5C11.366 0.5 14.5 3.63401 14.5 7.5C14.5 9.73096 13.4563 11.7182 11.8306 13M11.5 10V13.5H15M0 1.5H3.5V5"}})
}
var staticRenderFns = []

export { render, staticRenderFns }